export type HighlightColorVariant = 'backgroundColor' | 'focus';

export enum HighlightColorVariantEnum {
  backgroundColor = 'backgroundColor',
  focus = 'focus',
}

export enum HighlightColorName {
  red = 'red',
  blue = 'blue',
  yellow = 'yellow',
  green = 'green',
  lilac = 'lilac',
  none = 'none',
}

export const HighlightColorSet = [
  HighlightColorName.red,
  HighlightColorName.blue,
  HighlightColorName.yellow,
  HighlightColorName.green,
  HighlightColorName.lilac,
  HighlightColorName.none,
] as const;

// Define type for color selection
export type ColorSelection = Record<
  (typeof HighlightColorName)[keyof typeof HighlightColorName],
  boolean
>;

export const HighlightOrderBy = {
  toc: 'toc',
  createdAt: 'createdAt',
} as const;

export type HighlightOrderByFilter =
  (typeof HighlightOrderBy)[keyof typeof HighlightOrderBy];
